function TelegramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M10 2C5.58065 2 2 5.58065 2 10C2 14.4194 5.58065 18 10 18C14.4194 18 18 14.4194 18 10C18 5.58065 14.4194 2 10 2ZM13.929 7.48064L12.6161 13.6677C12.5194 14.1065 12.2581 14.2129 11.8935 14.0065L9.89355 12.5323L8.92903 13.4613C8.82258 13.5677 8.73226 13.6581 8.52581 13.6581L8.66774 11.6226L12.3742 8.27419C12.5355 8.13226 12.3387 8.05161 12.1258 8.19355L7.54516 11.0774L5.57097 10.4613C5.14194 10.3258 5.13226 10.0323 5.66129 9.82581L13.3742 6.85161C13.7323 6.72258 14.0452 6.93871 13.929 7.48064Z"
        fill="url(#paint0_linear_1725_9206)"
      />
      <path
        d="M10 2C5.58065 2 2 5.58065 2 10C2 14.4194 5.58065 18 10 18C14.4194 18 18 14.4194 18 10C18 5.58065 14.4194 2 10 2ZM13.929 7.48064L12.6161 13.6677C12.5194 14.1065 12.2581 14.2129 11.8935 14.0065L9.89355 12.5323L8.92903 13.4613C8.82258 13.5677 8.73226 13.6581 8.52581 13.6581L8.66774 11.6226L12.3742 8.27419C12.5355 8.13226 12.3387 8.05161 12.1258 8.19355L7.54516 11.0774L5.57097 10.4613C5.14194 10.3258 5.13226 10.0323 5.66129 9.82581L13.3742 6.85161C13.7323 6.72258 14.0452 6.93871 13.929 7.48064Z"
        fill="black"
        fill-opacity="0.2"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1725_9206"
          x1="2"
          y1="-3.14286"
          x2="21.6691"
          y2="-0.275742"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#003ED9" />
          <stop offset="1" stop-color="#6EBDF9" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default TelegramIcon;
